export const usAdminAppRoutes = {
  index: "/us-admin-app",
  vendors: "/us-admin-app/vendors",
  distributors: "/us-admin-app/distributors",
  territoryManagers: "/us-admin-app/territory-managers",
  industrySpecialists: "/us-admin-app/industry-specialists",
  endUsers: "/us-admin-app/end-users",
  createVendor: "/us-admin-app/vendors/create",
  editVendor: "/us-admin-app/vendors/:entityId/edit",
  viewVendor: "/us-admin-app/vendors/:entityId/view",
  createIndustrySpecialist: "/us-admin-app/industry-specialists/create",
  editIndustrySpecialist: "/us-admin-app/industry-specialists/:entityId/edit",
  viewIndustrySpecialist: "/us-admin-app/industry-specialists/:entityId/view",
  createTerritoryManager: "/us-admin-app/territory-managers/create",
  editTerritoryManager: "/us-admin-app/territory-managers/:entityId/edit",
  viewTerritoryManager: "/us-admin-app/territory-managers/:entityId/view",
  createDistributor: "/us-admin-app/distributors/create",
  editDistributor: "/us-admin-app/distributors/:entityId/edit",
  viewDistributor: "/us-admin-app/distributors/:entityId/view",
  createEndUser: "/us-admin-app/end-users/create",
  editEndUser: "/us-admin-app/end-users/:entityId/edit",
  viewEndUser: "/us-admin-app/end-users/:entityId/view",
} as const;
